define('lq/events/actions/openDocumentInOfficeOnline',[
    'underscore',
    'lq/events/actions/eventAction',
    'lq',
    'lq/util',
    'lq/dispatcher',
    'lq/cookie',
    'lq/formSubmission'
], function (_, EventAction, lq, util, dispatcher, cookie, FormSubmission) {
    'use strict';

    function OpenDocumentInOfficeOnline(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        this.eventData = eventData;
        return this;
    }

    EventAction.extend(OpenDocumentInOfficeOnline, EventAction);

    OpenDocumentInOfficeOnline.typeName = 'OpenDocumentInOfficeOnline';

    OpenDocumentInOfficeOnline.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    OpenDocumentInOfficeOnline.prototype.execute = function (continuation) {
        var self = this;

        var documentId = self.piping.parameters.getValue(self.eventData.idParameter);
        if (!documentId) {
            continuation();
            return;
        }

        var wopiWindowName = 'wopi-window-' + self.eventData.commandId + '-' + Date.now();
        var wopiWindow = window.open('', wopiWindowName);

        //var onPostMessage = function(event) {
        //    console.log('WOPI PostMessage', event);
        //}

        //wopiWindow.addEventListener('message', onPostMessage);
        //window.addEventListener('message', onPostMessage);

        var form = new FormSubmission(self.piping.url.prepare(lq.getTenantUrl('Wopi/Open')), wopiWindowName);
        form.addProperty('actionId', self.piping.actionId);
        form.addProperty('commandId', self.eventData.commandId);
        form.addProperty('documentId', documentId);
        form.addParameters('parameters', self.piping.parameters.getNonSystemParameters());
        form.submit();

        var isClosed = false;
        var closedTime = null;
        var lastModificationDate = null;

        var closedTimer = setInterval(function () {
            if (wopiWindow.closed) {
                clearInterval(closedTimer);

                isClosed = true;
                closedTime = Date.now();

                //wopiWindow.removeEventListener('message', onPostMessage);
                //window.removeEventListener('message', onPostMessage);

                if (self.eventIsEnabled('closed'))
                    self.triggerEvent('closed');
            }
        }, 500);

        if (self.eventIsEnabled('saved') || self.eventIsEnabled('savedafterclosed')) {
            var checkIsSaved = function () {
                var interval = 2000;
                var giveUpAfter = 30000;

                if (isClosed && (Date.now() - closedTime) > giveUpAfter) {
                    if (self.eventIsEnabled('savedafterclosed'))
                        self.triggerEvent('savedafterclosed');
                    return;
                }

                dispatcher.dispatch(
                    'Wopi/GetModificationDate',
                    {
                        actionId: self.piping.actionId,
                        commandId: self.eventData.commandId,
                        documentId: documentId
                    },
                    function (result) {
                        var isSaved = lastModificationDate && lastModificationDate !== result;
                        lastModificationDate = result;

                        if (isSaved) {
                            if (self.eventIsEnabled('saved'))
                                self.triggerEvent('saved');

                            if (isClosed) {
                                if (self.eventIsEnabled('savedafterclosed'))
                                    self.triggerEvent('savedafterclosed');
                                return;
                            }
                        }

                        setTimeout(checkIsSaved, interval);
                    },
                    { global: false },
                    function () {
                        setTimeout(checkIsSaved, interval);
                    });
            };

            checkIsSaved();
        }

        continuation();
    };

    return OpenDocumentInOfficeOnline;
});
